import React from 'react';
import classNames from 'classnames';

import './product-variant.scss';

interface ProductVariantProps {
    name: string;
    url: string;
    isActive: boolean;
    isDisable: boolean;
}

const ProductVariant: React.FC<ProductVariantProps> = ({
    name,
    url,
    isActive,
    isDisable
}) => {
    return (
        <a
            href={url}
            className={classNames('product-variant', {
                'product-variant--active': isActive,
                'product-variant--disable': isDisable
            })}
        >
            {name}
        </a>
    );
};

export default ProductVariant;
